"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterBooleanCell = void 0;
const react_1 = __importDefault(require("react"));
const select_1 = require("../../../components/select/select");
const react_intl_1 = require("react-intl");
const list_source_hook_1 = require("../../../utils/list-source-hook");
function FilterBooleanCell({ disabled, value, onChange, }) {
    const intl = react_intl_1.useIntl();
    return (react_1.default.createElement(select_1.Select, { disabled: disabled, source: list_source_hook_1.useStaticListSource([
            {
                id: 'true',
                name: intl.formatMessage({
                    id: 'EAS_TABLE_FILTER_CELL_BOOLEAN_OPTION_SELECTED',
                    defaultMessage: 'Vybrané',
                }),
            },
            {
                id: 'false',
                name: intl.formatMessage({
                    id: 'EAS_TABLE_FILTER_CELL_BOOLEAN_OPTION_NOT_SELECTED',
                    defaultMessage: 'Nevybrané',
                }),
            },
        ]), value: value, onChange: onChange, valueIsId: true }));
}
exports.FilterBooleanCell = FilterBooleanCell;
//# sourceMappingURL=filter-boolean-cell.js.map